export function initialsOf(fullName: string): string {
  const initials = fullName
    .split(/\s+/)
    .map((str) => str[0])
    .join('')
    .toUpperCase();
  // If there are more than 2 initials, keep only the first and last one
  return initials.length > 2 ? `${initials[0]}${initials[initials.length - 1]}` : initials;
}
